import React, { useState, useContext } from "react";
import { AuthContext } from "../../context/AuthContext";

const LogoDesignSection = () => {
  const [activeTab, setActiveTab] = useState("Logo Design");

  const dataContext = useContext(AuthContext);
  if (!dataContext) return null;
  const { theme } = dataContext;

  const tabs = [
    { name: "Logo Design", id: "logo-design" },
    { name: "Social Media Design", id: "social-media-design" },
    { name: "Website", id: "website-section" },
    { name: "Brochures", id: "brochures-section" },
    { name: "Social Media Growth", id: "social-media-growth" },
  ];

  const handleScroll = (id: string, name: string) => {
    setActiveTab(name);
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <div
      className={`w-full flex justify-center sticky top-[110px] z-50 py-3 sm:py-4 transition-all duration-500 px-2 sm:px-10 md:px-20 logo-design-toolbar ${
        theme === "dark" ? "bg-white text-black" : "bg-black text-white"
      }`}
    >
      <div
        className={`grid grid-cols-5 w-full max-w-[1536px] border-2 rounded-xl overflow-hidden backdrop-blur-lg transition-all duration-500 ${
          theme === "dark" ? "border-purple-600" : "border-purple-600"
        }`}
      >
        {tabs.map((tab, index) => {
          const isActive = activeTab === tab.name;
          return (
            <button
              key={tab.name}
              onClick={() => handleScroll(tab.id, tab.name)}
              className={`
                flex items-center justify-center text-center font-semibold transition-all duration-300
                ${
                  isActive
                    ? "bg-purple-600 text-white"
                    : theme === "dark"
                    ? "bg-transparent text-gray-800 hover:bg-gray-300"
                    : "bg-transparent text-gray-200 hover:bg-purple-700 hover:text-white"
                }
                border-r last:border-r-0 border-purple-600
                text-[8.5px] xs:text-[10px] sm:text-sm md:text-base lg:text-lg
                py-[6px] sm:py-3 md:py-4 px-[2px] sm:px-3
              `}
            >
              {tab.name}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default LogoDesignSection;
